import { FILTER_TYPES } from 'components/FilterPod';
const PHIZIK_STATUS = [
  {
    value: 'PHYSICAL_CARD_REQUEST_STATUS_LOGICALLY_ISSUED',

    label: 'صادر شده ',
  },
  {
    value: 'PHYSICAL_CARD_STATUS_PRINT_REQUESTED',

    label: 'درخواست شده',
  },
  {
    value: 'PHYSICAL_CARD_STATUS_PRINTED',

    label: 'چاپ شده',
  },
  {
    value: 'PHYSICAL_CARD_STATUS_ACTIVATED',

    label: 'فعال شده',
  },
  {
    value: 'PHYSICAL_CARD_REQUESTED_STATUS_PRINT_FAIED',

    label: 'ناموفق',
  },
];
const CARD_STATUS = [
  {
    value: 'CARD_REQUESTED_STATUS_ACCEPTED',

    label: 'پذیرفته شده ',
  },
  {
    value: 'CARD_REQUESTED_STATUS_WAIT_ACTIVATE',

    label: 'در انتظار فعال شدن',
  },
  {
    value: 'CARD_REQUESTED_STATUS_ACTIVATED',

    label: 'فعال شده',
  },
];
const filters = () => [
  {
    title: 'شناسه درخواست',
    label: 'شناسه درخواست',
    keyName: 'id',
    query: 'id',
    id: 1,
    value: null,
    filterType: FILTER_TYPES.text,
    filterProps: { dir: 'ltr', englishNumber: true },
  },


  {
    title: 'وضعیت  درخواست مجازی کارت',
    label: 'وضعیت  درخواست مجازی کارت',
    keyName: 'cardStatus',
    query: 'cardStatus',
    id: 3401,
    value: null,
    filterType: FILTER_TYPES.select,
    filterProps: {
      options: CARD_STATUS,
    },
  },

  {
    title: 'وضعیت  درخواست فیزیکی کارت',
    label: 'وضعیت  درخواست فیزیکی کارت',
    keyName: 'physicalStatus',
    query: 'physicalStatus',
    id: 3401,
    value: null,
    filterType: FILTER_TYPES.select,
    filterProps: {
      options: PHIZIK_STATUS,
    },
  },
  {
    title: 'شناسه کاربر',
    label: 'شناسه کاربر',
    keyName: 'userId',
    query: 'userId',
    id: 2,
    value: null,
    filterType: FILTER_TYPES.text,
    filterProps: { dir: 'ltr', englishNumber: true },
  },
];

export default filters;
